module.exports = "<p>\n  institute-and-center works!\n</p>\n"